// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_style_input__2mSIy","el":"Input_style_el__1g22O","total_text":"Input_style_total_text__1oXSO"};